import { render, staticRenderFns } from "./AutoApprovalParametersForm.vue?vue&type=template&id=465088e6&scoped=true"
import script from "./AutoApprovalParametersForm.vue?vue&type=script&lang=ts"
export * from "./AutoApprovalParametersForm.vue?vue&type=script&lang=ts"
import style0 from "./AutoApprovalParametersForm.vue?vue&type=style&index=0&id=465088e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465088e6",
  null
  
)

export default component.exports